<template>
<div class="chapter">
<div class="inner_page">
<div id="Halftitle">
<p class="halftitle"><a id="page_5"></a><span class="bold">Braving the Workplace</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Halftitle.vue?3005372c